import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import logo from "../../images/logo.svg";
import Avatar from "@mui/material/Avatar";
import { getApplicationData } from "../../requests";

const ResponsiveAppBar = ({
  bgcolor = "#f2f3f5",
  btnbgcolor = "#f2f3f5",
  fgcolor = "black",
  city,

}) => {


  const [anchorEl, setAnchorEl] = useState(null);
  const [breadcrumbPath, setBreadcrumbPath] = useState(['Home']);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (path, label) => {
    setBreadcrumbPath((prevPath) => [...prevPath, label]);
    navigate(path);
    handleClose();
  };


  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [enteredValue, setEnteredValue] = useState("");
  const [lokalniData, setLokalniData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [name, setName] = useState();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const searchedPlace = localStorage.getItem("searchedPlace");
  const placeID = localStorage.getItem("placeID");

  const pages = [{ name: "WYSZUKIWARKA", url: "/" }, { name: "O NAS", url: "/onas/" }, { name: "USŁUGI", url: "/uslugi/" },
  { name: "BLOG", url: "/blog/" }, { name: "KONTAKT", url: "/kontakt/" },
  { name: "MAPA DOBRA", url: placeID ? `/mapadobra/${searchedPlace}/${placeID}` : enteredValue ? `/mapadobra/${enteredValue}` : `/mapadobra/${city}` }];

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
    const label = event.target.innerText.trim();
    switch (label) {
      case "BLOG":
        window.location.href = 'http://lokalni.pl/blog/';
        break;

      case "O NAS":
        navigate(`/onas/`);
        break;

      case "USŁUGI":
        navigate(`/uslugi/`);
        break;

      case "MAPA DOBRA":

        if (placeID) {
          navigate(`/mapadobra/${searchedPlace}/${placeID}`);
        } else if (enteredValue) {
          navigate(`/mapadobra/${enteredValue}`);
        } else {
          navigate(`/mapadobra/${city}`);
        }
        break;

      case "WYSZUKIWARKA":
        navigate(`/`);
        break;

      case "KONTAKT":
        window.location.href = 'http://lokalni.pl/kontakt/';
        break;

      default:
        console.log(`Sorry, we are out of ${name}.`);
    }
  };


  useEffect(() => {
    getApplicationData()
      .then((results) => {
        if (
          results.status !== 200 &&
          results.status !== 201 &&
          results.status !== 202 &&
          results.status !== 203
        ) {
          setLokalniData({});
          return;
        }
        return results.json();
      })
      .then((result) => {
        if (result.status === "Company not found") {
          setLokalniData({});
          return;
        }
        const dane = result;
        setLokalniData(dane);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Actuator => ERROR HAS OCCURRED: " + error);
      });
  }, []);



  return (
   
    <AppBar
      position="sticky"
      id="header-test"
      sx={{
        gridArea: "nav",
        width: "100vw",
        backgroundColor: `${bgcolor}`,
        color: `${fgcolor}`,
        position: 'fixed',
        pl: "32px",
        pr: "32px",
        height: '64px',
      }}
    >

      <Toolbar disableGutters sx={{
          width: "100%",
          justifyContent: "space-between",
          minHeight: '64px',
      }}>

        <Avatar alt="Logo" src={logo} sx={{ width: "200px", height: "58px" }} variant="square" onClick={() => {
          navigate(`/`);
        }} />

        <Box
          sx={{
            flexGrow: { md: "1", sm: "1" },
            display: { xs: "flex", md: "none", sm: "flex" },
            justifyContent: "end",
          }}
        >
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>

          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElNav)}
            onClose={handleClose}
            sx={{
              display: { xs: "block", md: "none", sm: "block" },
            }}
          >
            {pages.map((page) => (
              <MenuItem key={page} onClick={handleCloseNavMenu}>
                <Typography textAlign="center">{page.name}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            flexGrow: { md: "1", sm: "1" },
            display: {
              xs: "none",
              md: "none",
              sm: "none",
              color: `${fgcolor}`,
            },
          }}
        >
         
        </Typography>
        <Box id="bigMenu">
          <Box
            sx={{

              flexGrow: { md: "2", sm: "2" },
              display: { xs: "none", md: "flex", sm: "none" },
            }}
          >
            <Breadcrumbs separator=""

            >
              {pages.map((page) => (
                <Button
                  key={page.name}
                  component="a"
                  onClick={() => navigate(page.url)}
                  sx={{
                    my: 2,
                    color: `${fgcolor}`,
                    display: "block",
                   

                  }}
                >
                  {page.name}
                </Button>
              ))}
            </Breadcrumbs>
          </Box>
        </Box>
      </Toolbar>

    </AppBar>

  );
};

ResponsiveAppBar.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.string),
  settings: PropTypes.arrayOf(PropTypes.string),
  bgcolor: PropTypes.string,
  btnbgcolor: PropTypes.string,
  fgcolor: PropTypes.string,
};

export default ResponsiveAppBar;
